// @flow

import EventEmitter from 'events';
import * as NeighborhoodActionType from 'action_types/NeighborhoodActionTypes';
import Dispatcher from 'dispatcher';
import _ from 'lodash';
import Neighborhood from 'models/Neighborhood';

const CHANGE = 'change';

let _neighborhoods = {};

class NeighborhoodStore extends EventEmitter {
  constructor(): void {
    super();
    Dispatcher.register(this._actionsHandler);
  }
  
  getNeighborhoods = (): any => {
    return _.values(_neighborhoods);
  };
  
  getNeighborhoodById = (id: string) => {
    return _neighborhoods[id];
  };
  
  addChangeListener = (callback: () => void, index?:any = '') => {
    this.on(CHANGE + index, callback);
  };
  
  removeChangeListener = (callback: () => void, index?:any = '') => {
    this.removeListener(CHANGE + index, callback);
  };
  
  _setNeighborhoods = (neighborhoods: Neighborhood[]) => {
    _neighborhoods = {};
    _.forEach(neighborhoods, (neighborhood) => {
      _neighborhoods[neighborhood.id] = neighborhood;
    });
  };
  
  _emitChange = (index?: number = '') => {
    this.emit(CHANGE + index);
  };

  _actionsHandler = (action: any) => {
    switch (action.type) {
      case NeighborhoodActionType.GET_NEAREST_NEIGHBORHOODS : {
        this._setNeighborhoods(action.neighborhoods);
        this._emitChange();
        break;
      }
      case NeighborhoodActionType.NEIGHBORHOODS_BY_ZIP: {
        this._setNeighborhoods(action.neighborhoods);
        this._emitChange(action.index);
        break;
      }
    }
  }
}

export default new NeighborhoodStore();
